import React from "react";

const NumInput = props => {

    return (
        <input type="number" className={"input " + props.className} onChange={e => props.set(e.target.value)} value={props.v} />
    );
}

export default NumInput;